export default __webpack_public_path__ + "static/media/10.58ffe6b9.mp3";